/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCalculatorAlt} from '@fortawesome/pro-duotone-svg-icons';

const TransactionTypeIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faCalculatorAlt} {...props} />
);

export default TransactionTypeIcon;
